import { configureStore } from '@reduxjs/toolkit';
import loginSlice from './loginSlice';
import tipo_identificacionSlice from './tipo_identificacionSlice';
import tipo_personaSlice from './tipo_personaSlice';
import tipo_propiedadSlice from './tipo_propiedadSlice';
import tipo_proveedorSlice from './tipo_proveedorSlice';
import tipo_categoriaSlice from './tipo_categoriaSlice';
import tipo_estadoSlice from './tipo_estadoSlice';
import usuarioSlice from './usuarioSlice';
import medio_pagoSlice from './medio_pagoSlice';
import moduloSlice from './moduloSlice';
import auditoriaSlice from './auditoriaSlice';
import pagoSlice from './pagoSlice';
import conjuntoSlice from './conjuntoSlice';
import administradorSlice from './administradorSlice';
import conjunto_administradorSlice from './conjunto_administradorSlice';
import personaSlice from './personaSlice';
import persona_propiedadSlice from './persona_propiedadSlice';
import propiedadSlice from './propiedadSlice';
import conjunto_subscripcionSlice from './conjunto_subscripcionSlice';
import conjunto_subscripcion_detalleSlice from './conjunto_subscripcion_detalleSlice';
import rol_permisoSlice from './rol_permisoSlice';
import permiso_adicionalSlice from './permiso_adicionalSlice';
import permiso_adicional_rolSlice from './permiso_adicional_rolSlice';
import rolSlice from './rolSlice';
import usuario_conjuntoSlice from './usuario_conjuntoSlice';
import usuario_conjunto_rolSlice from './usuario_conjunto_rolSlice';
import presupuestoSlice from './presupuestoSlice';
import presupuesto_detalleSlice from './presupuesto_detalleSlice';
import presupuesto_ejecucionSlice from './presupuesto_ejecucionSlice';
import cuota_administracionSlice from './cuota_administracionSlice';
import factura_administracionSlice from './factura_administracionSlice';
import resolucion_facturacionSlice from './resolucion_facturacionSlice';
import proveedorSlice from './proveedorSlice';
import commonsSlice from './commonSlice';
import navigationSlice from './navegacionSlice';
import tareaSlice from './tareaSlice';
import comunicadoSlice from './comunicadoSlice';
import comunicacionSlice from './comunicacionSlice';
import { tipo_pagoSlice } from './tipo_pagoSlice';


export default configureStore({
  reducer: {
    login: loginSlice,
    common: commonsSlice,
    navigation: navigationSlice,
    tipo_identificacion: tipo_identificacionSlice,
    tipo_persona: tipo_personaSlice,
    tipo_propiedad: tipo_propiedadSlice,
    tipo_proveedor: tipo_proveedorSlice,
    tipo_categoria: tipo_categoriaSlice,
    tipo_estado: tipo_estadoSlice,
    tipo_pago: tipo_pagoSlice,
    usuario: usuarioSlice,
    medio_pago: medio_pagoSlice,
    modulo: moduloSlice,
    auditoria: auditoriaSlice,
    pago: pagoSlice,
    conjunto: conjuntoSlice,
    administrador: administradorSlice,
    conjunto_administrador: conjunto_administradorSlice,
    persona: personaSlice,
    persona_propiedad: persona_propiedadSlice,
    propiedad: propiedadSlice,
    conjunto_subscripcion: conjunto_subscripcionSlice,
    conjunto_subscripcion_detalle: conjunto_subscripcion_detalleSlice,
    rol_permiso: rol_permisoSlice,
    permiso_adicional: permiso_adicionalSlice,
    permiso_adicional_rol: permiso_adicional_rolSlice,
    rol: rolSlice,
    usuario_conjunto: usuario_conjuntoSlice,
    usuario_conjunto_rol: usuario_conjunto_rolSlice,
    presupuesto: presupuestoSlice,
    presupuesto_detalle: presupuesto_detalleSlice,
    presupuesto_ejecucion: presupuesto_ejecucionSlice,
    cuota_administracion: cuota_administracionSlice,
    factura_administracion: factura_administracionSlice,
    resolucion_facturacion: resolucion_facturacionSlice,
    proveedor: proveedorSlice,
    tarea: tareaSlice,
    comunicado: comunicadoSlice,
    comunicacion: comunicacionSlice
  }
})